<template>
  <v-app class="application--is-rtl main-app" app-data="true">
    <Nuxt />
  </v-app>
</template>

<script>
export default {
  name: 'employmentIndexLayout',
}
</script>